import { useQuery } from '@tanstack/react-query';
import { residentApi, type ResidentDetails } from '../api';
import type { ResidentFiltersType } from '../components';

export const useResidentsQuery = (filters: ResidentFiltersType) => {
  return useQuery({
    queryKey: ['residents', filters],
    queryFn: () => residentApi.getAllResidentWithFilters(filters),
  });
};

export const useResidentDetails = (residentId: string) => {
  return useQuery<ResidentDetails>({
    queryKey: ['resident', residentId],
    queryFn: () => residentApi.getResidentById(residentId),
    enabled: !!residentId, // only runs when ID exists
  });
};

export const useArchivedResidentsQuery = (filters: ResidentFiltersType) => {
  return useQuery({
    queryKey: ['archived-residents', filters],
    queryFn: () => residentApi.getArchivedResidentWithFilters(filters),
  });
};
